import React              from 'react';
import { LinkOutlined }   from '@ant-design/icons';
import { ExportOutlined } from '@ant-design/icons';
import View               from '@widesk-ui/components/View';
import Input              from '@widesk-ui/components/form/Input';
import Button             from '@widesk-ui/components/Button';
import Tooltip            from '@widesk-ui/components/Tooltip';
import useDesignTokens    from '@/hooks/useDesignTokens';

const withScheme = (value: string) => (
	value && value.length >= 8 && !/^https?:\/\//.test(value) ? `https://${value}` : value
);

/** Même logique qu'`InputUrl` de widesk (`https://` ajouté), présenté comme les autres champs. */
export default function UrlFieldInput(props: {
	value?: string;
	onChange?: (value?: string) => void;
	placeholder?: string;
}) {
	const tokens = useDesignTokens();
	const value = props.value || '';

	return (
		<View row gap="xs">
			<View flex>
				<Input
					allowClear
					type="url"
					prefix={<LinkOutlined style={{ color: tokens.text.muted }} />}
					placeholder={props.placeholder}
					value={value}
					// Hors `Form.Item` comme dedans, l'`Input` de widesk transmet l'événement d'antd et non la
					// valeur annoncée par son type.
					onChange={(e: unknown) => {
						const raw = (e as React.ChangeEvent<HTMLInputElement>).target?.value ?? String(e ?? '');

						props.onChange?.(withScheme(raw) || undefined);
					}}
				/>
			</View>

			<Tooltip title={value ? 'Ouvrir le lien' : undefined}>
				<Button
					icon={<ExportOutlined />}
					disabled={!value}
					onClick={() => window.open(value, '_blank', 'noopener,noreferrer')}
					style={{ width: 40, flexShrink: 0, padding: 0 }}
				/>
			</Tooltip>
		</View>
	);
}
